export const INTAKE_LIST_REQUEST = "INTAKE_LIST_REQUEST"
export const INTAKE_LIST_SUCCESS = "INTAKE_LIST_SUCCESS"
export const INTAKE_LIST_FAIL = "INTAKE_LIST_FAIL"

